<template>
    <a :href="url" class="card card--fixed card--backed-white">
        <div class="media-wrap">
            <img :src="image_url" :alt="title">
        </div>
        <h3 class="card__title">{{ title }}</h3>
        <time class="card__text card__text--date" :datetime="date" v-if="hide_date == false">{{ date }}</time>
    </a>
</template>

<script>
export default {
    props: {
        image_url: String,
        title: String,
        date: Date,
        url: String,
        hide_date: Boolean
    }
}
</script>
